import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, Mail, Phone } from 'lucide-react';
import Logo from '../components/Logo';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Footer = () => {
  const navigate = useNavigate();
  const [branding, setBranding] = useState({ logo_url: '/taskpiece-logo.png', site_name: 'TaskPiece' });

  useEffect(() => {
    axios.get(`${API}/settings/branding`).then(r => setBranding(r.data)).catch(() => {});
  }, []);

  const siteName = branding.site_name || 'TaskPiece';

  return (
    <footer className="bg-slate-900 text-slate-300 mt-auto" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div
              className="font-heading text-xl font-bold text-white cursor-pointer mb-3"
              onClick={() => navigate('/')}
              data-testid="footer-logo"
            >
              {branding.logo_url ? (
                <img src={branding.logo_url} alt={siteName} className="h-8 max-w-[180px] object-contain" />
              ) : (
                <Logo className="h-8 max-w-[180px] object-contain" />
              )}
            </div>
            <p className="text-sm leading-relaxed text-slate-400">
              India's trusted freelance marketplace with secure escrow payments, milestone contracts, and verified professionals.
            </p>
            <div className="mt-4 space-y-2 text-sm text-slate-400">
              <div className="flex items-start gap-2">
                <MapPin className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
                <span>6th Floor, Forum Mart, Satya Nagar, Bhubaneswar, Odisha 751001</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-3.5 h-3.5 flex-shrink-0" />
                <span>support@taskpiece.com</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-3.5 h-3.5 flex-shrink-0" />
                <span>+91 674 234 5678</span>
              </div>
            </div>
          </div>

          {/* Platform */}
          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">Platform</h4>
            <ul className="space-y-2.5 text-sm">
              <li><button onClick={() => navigate('/explore')} className="hover:text-white transition-colors" data-testid="footer-explore">Explore Marketplace</button></li>
              <li><button onClick={() => navigate('/signup')} className="hover:text-white transition-colors" data-testid="footer-signup">Get Started</button></li>
              <li><button onClick={() => navigate('/login')} className="hover:text-white transition-colors" data-testid="footer-login">Sign In</button></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">Company</h4>
            <ul className="space-y-2.5 text-sm">
              <li><button onClick={() => navigate('/page/about')} className="hover:text-white transition-colors" data-testid="footer-about">About Us</button></li>
              <li><button onClick={() => navigate('/page/contact')} className="hover:text-white transition-colors" data-testid="footer-contact">Contact Us</button></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">Legal</h4>
            <ul className="space-y-2.5 text-sm">
              <li><button onClick={() => navigate('/page/terms')} className="hover:text-white transition-colors" data-testid="footer-terms">Terms & Conditions</button></li>
              <li><button onClick={() => navigate('/page/privacy-policy')} className="hover:text-white transition-colors" data-testid="footer-privacy">Privacy Policy</button></li>
              <li><button onClick={() => navigate('/page/refund-policy')} className="hover:text-white transition-colors" data-testid="footer-refund">Refund Policy</button></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-slate-800 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-slate-500" data-testid="footer-copyright">
            &copy; {new Date().getFullYear()} Kottakota Regtech Solutions Pvt Ltd. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-slate-500">
            <button onClick={() => navigate('/page/terms')} className="hover:text-slate-300 transition-colors">Terms</button>
            <span className="text-slate-700">|</span>
            <button onClick={() => navigate('/page/privacy-policy')} className="hover:text-slate-300 transition-colors">Privacy</button>
            <span className="text-slate-700">|</span>
            <button onClick={() => navigate('/page/refund-policy')} className="hover:text-slate-300 transition-colors">Refunds</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
